import React, { Component, } from 'react';
// react modal
import ReactModal from 'react-modal';
// prop types
import PropTypes from 'prop-types';
// react redux connect
import { connect } from 'react-redux';
// lodash isempty
import { isEmpty } from 'lodash';
// styled components
import styled from 'styled-components';

// icon imports
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

// moment utils for MuiPickersUtilsProvider
import MomentUtils from '@date-io/moment';
// material ui pickers
import {
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';

// material ui core imports
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CircularProgress,
  Button,
  IconButton,
  Grid,
  withStyles,
} from '@material-ui/core';

// homemade component imports
import {
  RegularCard,
  ItemGrid,
  CustomInput,
  UploadButton
} from "../../components";
// reducer imports
import {
  loadLotto,
  setLotto,
  createNewLotto,
  editLotto,
  deleteLotto
} from './reducer/actions';

// modal styles: header, content, footer
const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  padding: 20px;
  border-bottom: 1px solid rgba(153, 153, 153, 0.7);
`
const ModalContent = styled.div`
  position: relative;
  padding: 20px 20px;
  overflow: hidden;
  padding-bottom: 20px;
  line-height: 50px;
`
const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
  border-top: 1px solid rgba(153, 153, 153, 0.7);
`
// modal style sheets
const customModalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(15, 102, 128, 0.5)'
  },
  content: {
    top: 0,
    left: window.innerWidth <= 950 ? '0%' : '50%',
    right: 'auto',
    bottom: 'auto',
    padding: '0px !important',
    width: window.innerWidth <= 500 ? '100%' : '500px',
  }
};

// custom table cell for table of Lottos
const CustomTableCell = withStyles(theme => ({
  head: {
    fontSize: 16,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

// last set of styles
const styles = theme => ({
  table: {
    maxWidth: 700,
  },
  row: {
    backgroundColor: theme.palette.background.default,
  },
});

// These are plastic! He can't fly!
// They're a lightweight barillium alloy and I CAN fly.

// class declaration
class Lottery extends Component {

  // constructor
  constructor (props) {
    super(props);
    // set up component state
    this.state = {
      date: '', // how the date is referred to by the api
      fetch: '', // the id of the api to fetch
      image: null, // header image
      multiplier: '', // how the multiplier is referred to by the api, if applicable
      name: '', // printable name of the lottery
      numbers: '', // how the numbers are referred to by the api
      pulls: 0, // how many normal balls are pulled
      range: 0, // the highest number in the pool
      rangeSpecial: 0, // highest number in extra/special pool
      specialBall: '', // how the special ball is referred to, if applicable
      showModal: false, // whether to show the create/edit modal
      isEditing: false, // whether editing, or creating
    };
  }

  // when loading in, load lottos
  componentDidMount() {
    this.props.loadLotto();
  }

  // on successful create/edit, close modal
  _onSuccess () {
    this.setState({ showModal: false });
  }

  // on unsuccessful create/edit, close modal and log error
  _onError (error) {
    this.setState({ showModal: false });
    console.log(error);
  }

  // send to reducer Delete Lotto function
  _onDeleteLotto (id) {
    this.props.deleteLotto(
      id, this._onSuccess.bind(this),
      this._onError.bind(this));
  }

  // called when opening the Modal to Edit a Lotto
  initEditLotto (id) {
    const { allLotto } = this.props;
    const curLotto = allLotto.filter(lotto => (lotto.id === id))[0];
    // get the proper Lotto to edit
    // and then set the state of the modal accordingly
    this.setState({
      date: curLotto.date,
      fetch: curLotto.fetch,
      image: curLotto.image ? curLotto.image : null,
      multiplier: curLotto.multiplier === '' ? null : curLotto.multiplier,
      name: curLotto.name,
      numbers: curLotto.numbers,
      pulls: curLotto.pulls,
      range: curLotto.range,
      rangeSpecial: curLotto.rangeSpecial === '' ? null : curLotto.rangeSpecial,
      specialBall: curLotto.specialBall === '' ? null : curLotto.specialBall,
      showModal: true,
      isEditing: true,
    });
  }

  // called when the Edit button is pressed
  _onEditLotto () {
    // set the properties of the edited lotto
    this.props.editLotto(this.state.fetch, {
      date: this.state.date,
      fetch: this.state.fetch,
      image: this.state.image ? this.state.image : null,
      multiplier: this.state.multiplier === '' ? null : this.state.multiplier,
      name: this.state.name,
      numbers: this.state.numbers,
      pulls: this.state.pulls,
      range: this.state.range,
      rangeSpecial: this.state.rangeSpecial === '' ? null : this.state.rangeSpecial,
      specialBall: this.state.specialBall === '' ? null : this.state.specialBall,
      showModal: false,
      isEditing: false,
    }, this._onSuccess.bind(this), this._onError.bind(this));
  }

  // called on pressing Create on the modal
  _onCreateNewLotto () {
    this.props.createNewLotto({[this.state.fetch]: {
      date: this.state.date,
      fetch: this.state.fetch,
      image: this.state.image ? this.state.image : null,
      multiplier: this.state.multiplier === '' ? null : this.state.multiplier,
      name: this.state.name,
      numbers: this.state.numbers,
      pulls: this.state.pulls,
      range: this.state.range,
      rangeSpecial: this.state.rangeSpecial === '' ? null : this.state.rangeSpecial,
      specialBall: this.state.specialBall === '' ? null : this.state.specialBall,
      showModal: false,
      isEditing: false,
    }}, this._onSuccess.bind(this), this._onError.bind(this));
  }

  // on showing the modal to Create a new lotto,
  // all the modal fields should be blank
  _onShowModal () {
    this.setState({
      date: '',
      fetch: '',
      image: '',
      multiplier: '',
      name: '',
      numbers: '',
      pulls: 0,
      range: 0,
      rangeSpecial: 0,
      specialBall: '',
      showModal: true,
      isEditing: false,
    })
  }

  // close the modal
  _onCloseModal () {
    this.setState({ showModal: false });
  }

  // render the create/edit modal
  lottoModal() {
    // if modal is not currently being shown, return immediately
    if (!this.state.showModal) {
      return null;
    }
    // return
    return (
      <ReactModal isOpen={this.state.showModal}
        onRequestClose={this._onCloseModal.bind(this)}
        closeTimeoutMS={450}
        contentLabel={this.state.isEditing ? 'Edit Game' : 'Add Game'}
        ariaHideApp={false}
        style={customModalStyles}
      >
        {/* Modal's header component */}
        <ModalHeader>
          {this.state.isEditing ? 'Edit Game' : 'Add Game'}
        </ModalHeader>
        {/* main modal content */}
        <ModalContent>
          <Grid container>
            {/* Header Image */}
            <ItemGrid xs={12}
              style={{
                alignContent: 'center',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {/* Upload a Lotto image */}
              <UploadButton
                storage="friends"
                value={this.state.image}
                onUploadComplete={uri => this.setState({ image: uri })}
              />
            </ItemGrid>
            <ItemGrid xs={6}>
            {/* Set the game title */}
            <CustomInput
                labelText='Printable Name'
                id='name'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.name,
                  onChange: (e)=>this.setState({ name: e.target.value })
                }}
              />
            </ItemGrid>
            {/* Set where to Fetch from */}
            <ItemGrid xs={6}>
              <CustomInput
                labelText='Fetch ID'
                id='fetch'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.fetch,
                  onChange: (e)=>this.setState({ fetch: e.target.value })
                }}
              />
            </ItemGrid>
            {/* Set where to get Numbers from */}
            <ItemGrid xs={6}>
              <CustomInput
                labelText='Numbers Field'
                id='numbers'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.numbers,
                  onChange: (e)=>this.setState({ numbers: e.target.value })
                }}
              />
            </ItemGrid>
            {/* Set where to retrieve the Multiplier */}
            <ItemGrid xs={6}>
              <CustomInput
                 labelText='Multiplier Field'
                 id='multiplier'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.multiplier,
                  onChange: (e)=>this.setState({ multiplier: e.target.value })
                }}
              />
            </ItemGrid>
            {/* Set how to retrieve pull date */}
            <ItemGrid xs={6}>
              <CustomInput
                labelText='Date Field'
                id='date'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.date,
                  onChange: (e)=>this.setState({ date: e.target.value })
                }}
              />
            </ItemGrid>
            {/* Set number of Pulls per lotto */}
            <ItemGrid xs={6}>
              <CustomInput
                labelText='# of Pulls'
                id='pulls'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.pulls,
                  onChange: (e)=>this.setState({ pulls: Number(e.target.value) })
                }}
              />
            </ItemGrid>
            {/* Set how to retrieve Special Ball*/}
            <ItemGrid xs={6}>
              <CustomInput
                labelText='Special Ball Field'
                id='specialBall'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.specialBall,
                  onChange: (e)=>this.setState({ specialBall: e.target.value })
                }}
              />
            </ItemGrid>
            {/* Set Range of pulled balls */}
            <ItemGrid xs={6}>
              <CustomInput
                labelText='Max Pull Number'
                id='range'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.range,
                  onChange: (e)=>this.setState({ range: e.target.value })
                }}
              />
            </ItemGrid>
            <ItemGrid xs={6}>
              <CustomInput
                labelText='Max Special Pull'
                id='rangeSpecial'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.rangeSpecial,
                  onChange: (e)=>this.setState({ rangeSpecial: e.target.value })
                }}
              />
            </ItemGrid>
          </Grid>
        </ModalContent>
        <ModalFooter>
          {/* Confirm create/edit */}
          <Button variant='raised'
            primary={true}
            onClick={(e) =>
              {this.state.isEditing ?
                this._onEditLotto()
                : this._onCreateNewLotto()} }>
            {this.state.isEditing ? 'Edit' : 'Create'}
          </Button>
          {/* or just cancel */}
          <Button variant='raised'
            style={{ marginLeft: 20 }}
            onClick={(e) =>
              {this.setState({ isEditing: false, showModal: false })}}>
            Cancel
          </Button>
        </ModalFooter>
      </ReactModal>
    );
  }

  // render function
  render() {
    // classes contains the Classes styles from above
    const {
      classes,
      allLotto,
      isLoading
    } = this.props;

    // if loading still in progress, just show a loading swirly
    if (isLoading) {
      return (
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <RegularCard
            cardTitle="Lottery"
            cardSubtitle="games"
            content={
              <TableRow>
                <TableCell colSpan={6}>
                  <CircularProgress />
                </TableCell>
              </TableRow>
            }
          />
        </MuiPickersUtilsProvider>
      )
    }

    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              {/*Top row of content descriptors */}
              {/* Header image of lotto */}
              <CustomTableCell>
                Image
              </CustomTableCell>
              {/* Printable name of lotto */}
              <CustomTableCell>
                Name
              </CustomTableCell>
              {/* Edit/Delete Buttons */}
              <CustomTableCell>
                Options
              </CustomTableCell>
            </TableRow>
          </TableHead>
          {/* print all lotto metadata in backend */}
          <TableBody>
            {/* display rows of added Lotto */}
            {!isLoading && !isEmpty(allLotto) && allLotto
              .map((n, id) => {
                return (
                  <TableRow key={id} className={classes.row}>
                    {/* attached Image display field */}
                    <TableCell
                      align={'center'}
                    >
                      <div
                        style={{
                          width: 120,
                          height: 50,
                          backgroundColor: '#ccc',
                          backgroundImage: `url("${n.image}")`,
                          backgroundSize: 'contain',
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: '50% 50%',
                        }}
                      />
                    </TableCell>
                    {/* lotto printable name field */}
                    <CustomTableCell component="th" scope="row">
                      { n.name }
                    </CustomTableCell>
                    {/* Edit and Delete buttons */}
                    <CustomTableCell>
                      <IconButton tooltip="Edit game"
                        onClick={(e) => {this.initEditLotto(n.id)}}>
                        <EditIcon />
                      </IconButton>
                      <IconButton tooltip="Delete game"
                        onClick={(e) => {this._onDeleteLotto(n.id)}}>
                        <DeleteIcon />
                      </IconButton>
                    </CustomTableCell>
                  </TableRow>
                ); // end of map return
              }) // end of map
            }
            {/* Add Game button */}
            <TableRow>
              <TableCell colSpan={6}>
                <Button style={{background: '#E5e5e5'}}
                  onClick={this._onShowModal.bind(this)}>
                  Add Game
                </Button>
              </TableCell>
            </TableRow>
            {/* end of table body */}
          </TableBody>
          {/* end of table */}
        </Table>
        { this.lottoModal() }
      </MuiPickersUtilsProvider>
    );
  }
} // end of class declaration

Lottery.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  allLotto: state.lottoReducer.lotto,
  isLoading: state.lottoReducer.isLoading
});

const mapDispatchToProps = {
  loadLotto,
  setLotto,
  createNewLotto,
  editLotto,
  deleteLotto,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Lottery));
